export const fringeBenefitTypes = {
  healthInsurance: {
    value: 0,
    label: "Health Insurance"
  },
  retirement: {
    value: 1,
    label: "Retirement/Pension"
  },
  lifeInsurance: {
    value: 2,
    label: "Life Insurance"
  },
  vacationSickTime: {
    value: 3,
    label: "Vacation/Sick Time"
  },
  holidayTime: {
    value: 4,
    label: "Holiday Time"
  },
  supplementalUnemployment: {
    value: 5,
    label: "Supplemental Unemployment Benefits"
  },
  apprenticeTraining: {
    value: 6,
    label: "Apprentice Training"
  }
};

export const fringeBenefitOptions = [
  {
    value: 0,
    label: "Health Insurance"
  },
  {
    value: 1,
    label: "Retirement/Pension"
  }
];
